function mascaraMoeda(value) {
  if (!value) {
    return 0
  }

  const onlyDigits = value
    .split("")
    .filter(s => /\d/.test(s))
    .join("")
    .padStart(3, "0")

  const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2)

  return parseFloat(digitsFloat)
}

export function maskPercentage(value) {
  return `${value > 0 ? '+' : ''}${value.toFixed(1)}%`
}

export function maskPhone(value) {
  if (!value) {
    return ""
  }

  const onlyDigits = value
    .split("")
    .filter(s => /\d/.test(s))
    .join("")
    .padStart(11, "0")
  const ddd = onlyDigits.slice(0, 2)
  const part1 = onlyDigits.slice(2, 7)
  const part2 = onlyDigits.slice(7)
  return `(${ddd}) ${part1}-${part2}`
}

function maskCurrency(valor, locale = 'pt-BR', currency = 'BRL') {
  if (isNaN(valor)) {
    valor = 0
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(valor)
}

function removeCaracteresEspeciais(str) {
  return str?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/-/ig, '_')
    .replace(/ /ig, '_') ?? ""
}

function numOrderFormat(numOrder) {
  if (numOrder === undefined || numOrder === null)
    return ''
  return String(numOrder).padStart(5, '0')
}

function convertValueTypeStock(type = null, value = 0) {
  if (!type) { return 0 }

  if (type === 'KG') {
    return `${value} KG`
  }

  if (type === 'UN') {
    return `${value} UN`
  }

  if (type === 'LT') {
    return `${value} LT`
  }
}

function downloadFile(url, name) {
  fetch(url)
    .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('something went wrong'))
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      // the filename you want
      a.download = name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(() => alert('Erro ao baixar arquivo'));
}

function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export const TypePayment = {
  card_credit: 'Cartão Crédito',
  card_debit: 'Cartão Débito',
  money: 'Dinheiro',
  pix: 'PIX',
  ifood: 'Ifood',
  vale: 'Vale'
}

export { mascaraMoeda, iOS, maskCurrency, removeCaracteresEspeciais, numOrderFormat, convertValueTypeStock, downloadFile }